import { getProposedEquity, getSuggestedEquity } from "lib/shared/proposals";
import { getProposedEquityColumnId, getSuggestedEquityColumnId } from "lib/shared/table-settings";
import { FieldType, GrantType } from "prisma/cm/client";

import { FieldDefinition, UsageModel } from "../../fieldDefinition";
import { FieldValueResolver } from "../../FieldValueResolver";
import { FieldSourceType } from "../../types";

export function fromGrantType(grantType: GrantType): FieldDefinition[] {
  const proposedGrantDef: FieldDefinition = new FieldDefinition({
    id: getProposedEquityColumnId(grantType),
    baseModel: UsageModel.Proposal,
    fieldSourceType: FieldSourceType.GRANT_TYPE,
    valueGetter: (proposal) => {
      if (!proposal) {
        return null;
      }

      if (FieldValueResolver.validateAsProposal(proposal)) {
        return getProposedEquity(proposal, grantType.id);
      }

      return null;
    },
    fieldTypes: [FieldType.NUMBER],
  });

  proposedGrantDef.label = `Proposed ${grantType.name} Grant`;
  proposedGrantDef.textPopulated = true;

  const suggestedEquityDef: FieldDefinition = new FieldDefinition({
    id: getSuggestedEquityColumnId(grantType),
    baseModel: UsageModel.Proposal,
    fieldSourceType: FieldSourceType.GRANT_TYPE,
    valueGetter: (proposal) => {
      if (!proposal) {
        return null;
      }
      if (FieldValueResolver.validateAsProposal(proposal)) {
        if (!proposal.eligibleForEquity) return 0;

        return getSuggestedEquity(proposal, grantType.id);
      }

      return null;
    },
    fieldTypes: [FieldType.NUMBER],
  });

  suggestedEquityDef.label = `Suggested ${grantType.name} Grant`;
  proposedGrantDef.textPopulated = true;

  return [proposedGrantDef, suggestedEquityDef];
}
